

const INTENDED_ROUTE_KEY = 'intendedRoute';

export const saveIntendedRoute = (pathname, search = '', hash = '') => {
  const authRoutes = ['/login', '/signup'];

  if (authRoutes.includes(pathname)) {
    return;
  }

  const intendedRoute = {
    pathname,
    search,
    hash,
    timestamp: Date.now()
  };

  try {
    localStorage.setItem(INTENDED_ROUTE_KEY, JSON.stringify(intendedRoute));
  } catch (error) {
    console.warn('Failed to save intended route:', error);
  }
};

export const getIntendedRoute = () => {
  try {
    const saved = localStorage.getItem(INTENDED_ROUTE_KEY);
    if (!saved) return null;

    const intendedRoute = JSON.parse(saved);

    const maxAge = 24 * 60 * 60 * 1000;
    if (Date.now() - intendedRoute.timestamp > maxAge) {
      clearIntendedRoute();
      return null;
    }

    return intendedRoute;
  } catch (error) {
    console.warn('Failed to get intended route:', error);
    clearIntendedRoute();
    return null;
  }
};

export const clearIntendedRoute = () => {
  try {
    localStorage.removeItem(INTENDED_ROUTE_KEY);
  } catch (error) {
    console.warn('Failed to clear intended route:', error);
  }
};

export const getFullPath = (intendedRoute) => {
  if (!intendedRoute) return null;

  return `${intendedRoute.pathname}${intendedRoute.search}${intendedRoute.hash}`;
};


export const consumeIntendedRoute = () => {
  const intendedRoute = getIntendedRoute();
  if (intendedRoute) {
    clearIntendedRoute();
    return getFullPath(intendedRoute);
  }
  return null;
};


export const shouldPreserveRoute = (pathname) => {
  const authRoutes = ['/login', '/signup'];
  const worksuiteRoutes = ['/worksuite/listOrganization', '/worksuite/createOrganization', '/worksuite/editOrganization'];

  return !authRoutes.includes(pathname) &&
    !worksuiteRoutes.some(route => pathname.startsWith(route));
};